import { LogoLoader } from './LogoLoader/LogoLoader';

export function AppLoaderPage({ error }: { error?: boolean | '' }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex items-center justify-center min-h-dvh p-6 bg-white sm:bg-gray-200"
    >
      <div className="flex flex-col gap-10 bg-white items-center justify-center px-6 py-8 w-full max-w-xl rounded-2xl">
        <LogoLoader size="lg" color="dark" />

        <p id="tagline" className="text-center text-sm text-gray-500">
          {error === '' || error
            ? 'Something Went Wrong! Redirecting...'
            : 'Preparing your experience…'}
        </p>
      </div>
    </div>
  );
}
